import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import classNames from 'classnames';

import { InventoryCard } from '@entities/equipmentInventory';

import { getInventorySortableId, INVENTORY_DND_TYPE } from '../../lib/dnd';
import cls from '../WarehouseColumn/WarehouseColumn.module.css';

import type { Warehouse } from '@entities/equipment';
import type { EquipmentInventoryStatus } from '@entities/equipmentInventory';
import type { UiDropdownSearchListItem } from '@shared/ui';

interface SortableInventoryCardProps {
    warehouseId: number;
    warehouseItem: Warehouse['items'][number];
    virtualStart: number;
    warehouses: UiDropdownSearchListItem[];
    hasFullAccess: boolean;
    canMove: boolean;
    onClick: () => void;
    onCopyClick: React.MouseEventHandler<HTMLLIElement>;
    onMoveClick: (toWarehouse: UiDropdownSearchListItem, closeDropdown: () => void) => void;
    onStatusClick: (
        status: EquipmentInventoryStatus
    ) => React.MouseEventHandler<HTMLLIElement> | undefined;
    onDeleteClick: React.MouseEventHandler<HTMLLIElement>;
    isActiveDragItem: boolean;
    isDragDisabled: boolean;
}

export const SortableInventoryCard = ({
    warehouseId,
    warehouseItem,
    virtualStart,
    warehouses,
    hasFullAccess,
    canMove,
    onClick,
    onCopyClick,
    onMoveClick,
    onStatusClick,
    onDeleteClick,
    isActiveDragItem,
    isDragDisabled,
}: SortableInventoryCardProps) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: getInventorySortableId(warehouseItem.guid),
        data: {
            type: INVENTORY_DND_TYPE,
            inventoryGuid: warehouseItem.guid,
            warehouseId,
        },
        disabled: isDragDisabled,
    });

    return (
        <div
            ref={setNodeRef}
            className={classNames(cls.virtualItem, {
                [cls.virtualItemDragging]: isDragging || isActiveDragItem,
            })}
            style={{
                top: virtualStart,
                transform: CSS.Transform.toString(transform),
                transition,
            }}
            {...attributes}
            {...listeners}
        >
            <InventoryCard
                guid={warehouseItem.guid}
                title={warehouseItem.title}
                amount={warehouseItem.amount}
                status={warehouseItem.status}
                image={warehouseItem.previewUrl}
                freeDate={warehouseItem.freeDate}
                warehouses={warehouses}
                hasFullAccess={hasFullAccess}
                canMove={canMove}
                onClick={onClick}
                onCopyClick={onCopyClick}
                onMoveClick={onMoveClick}
                onStatusClick={onStatusClick}
                onDeleteClick={onDeleteClick}
            />
        </div>
    );
};
